"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Sync_1 = require("./Sync");
var SyncUtils_1 = require("../SyncUtils");
var ListModel = /** @class */ (function () {
    function ListModel(items) {
        var _this = this;
        this.sync = new Sync_1.Sync();
        this.items = [];
        this._onLoad = function (r) {
            if (r) {
                if (Array.isArray(r)) {
                    _this.setItems(r);
                }
                else {
                    _this.setItems(r.items ? r.items : [], r ? r.total : undefined);
                }
            }
            _this.sync.syncEnd();
        };
        this._onError = function (error) {
            _this.clearItems();
            _this.sync.syncError(error);
        };
        if (items) {
            this.setItems(items);
        }
    }
    Object.defineProperty(ListModel.prototype, "total", {
        get: function () {
            return this._total !== undefined ? this._total : this.items ? this.items.length : 0;
        },
        set: function (value) {
            this.setTotal(value);
        },
        enumerable: true,
        configurable: true
    });
    ListModel.prototype.setTotal = function (total) {
        this._total = total;
    };
    ListModel.prototype._setItemsInternal = function (items) {
        var _this = this;
        this.items = [];
        if (items) {
            items.forEach(function (item) { return _this.items.push(item); });
        }
    };
    ListModel.prototype.setItems = function (items, total) {
        this.setTotal(total);
        this._setItemsInternal(items);
        // ensure sync end is called when items are set
        this.sync.syncEnd();
    };
    ListModel.prototype.setValue = function (value) {
        this.setItems(value);
    };
    ListModel.prototype.clearItems = function () {
        this.setItems([], undefined);
    };
    ListModel.prototype.clearValue = function () {
        this.clearItems();
    };
    ListModel.prototype._addItemInternal = function (item, atIndex) {
        if (atIndex !== undefined && (atIndex >= 0 || atIndex < this.items.length - 1)) {
            this.items.splice(atIndex, 0, item);
        }
        else {
            this.items.push(item);
        }
    };
    ListModel.prototype.addItem = function (item, atIndex) {
        if (atIndex >= 0 || atIndex < this.items.length - 1) {
            this.items.splice(atIndex, 0, item);
        }
        else {
            this.items.push(item);
        }
    };
    ListModel.prototype.addItems = function (items, atIndex) {
        var _this = this;
        if (items) {
            items.forEach(function (item, idx) {
                _this.addItem(item, atIndex >= 0 ? atIndex + idx : undefined);
            });
        }
    };
    Object.defineProperty(ListModel.prototype, "itemsView", {
        get: function () {
            return this.items.slice(0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "value", {
        get: function () {
            return this.itemsView;
        },
        enumerable: true,
        configurable: true
    });
    ListModel.prototype.clear = function () {
        this.setItems([]);
        this.sync.clear();
    };
    ListModel.prototype._loadImpl = function () {
        return Promise.reject({ code: "NOT_IMPLEMENTED", message: "_loadImpl() not implemented" });
    };
    ListModel.prototype.refresh = function () {
        if (this.sync.syncing) {
            return SyncUtils_1.toPromise(this.sync);
        }
        this.sync.syncStart({ type: "load" });
        return this._loadImpl().then(this._onLoad).catch(this._onError);
    };
    ListModel.prototype.load = function () {
        if (this.sync.syncing) {
            return SyncUtils_1.toPromise(this.sync);
        }
        if (!this.sync.hasSynced || this.sync.error) {
            return this.refresh();
        }
        return Promise.resolve();
    };
    __decorate([
        mobx_1.observable
    ], ListModel.prototype, "sync", void 0);
    __decorate([
        mobx_1.observable
    ], ListModel.prototype, "_total", void 0);
    __decorate([
        mobx_1.observable
    ], ListModel.prototype, "items", void 0);
    __decorate([
        mobx_1.computed
    ], ListModel.prototype, "total", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "setTotal", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "setItems", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "setValue", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "clearItems", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "clearValue", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "_addItemInternal", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "addItem", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "addItems", null);
    __decorate([
        mobx_1.computed
    ], ListModel.prototype, "itemsView", null);
    __decorate([
        mobx_1.computed
    ], ListModel.prototype, "value", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "clear", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "_onLoad", void 0);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "_onError", void 0);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "refresh", null);
    __decorate([
        mobx_1.action
    ], ListModel.prototype, "load", null);
    return ListModel;
}());
exports.default = ListModel;
exports.ListModel = ListModel;
